export default __webpack_public_path__ + "static/media/1838.a9f0673c.png";